import { render, staticRenderFns } from "./Url.vue?vue&type=template&id=a97ab204&scoped=true&"
import script from "./Url.vue?vue&type=script&lang=js&"
export * from "./Url.vue?vue&type=script&lang=js&"
import style0 from "./Url.vue?vue&type=style&index=0&id=a97ab204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97ab204",
  null
  
)

export default component.exports